import React from 'react';
import { BUTTON_CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const ChevronDown: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.chevronDown')}</title>
        <path
            d='M3.33301 6.66675L7.99967 10.6667L12.6663 6.66675'
            stroke={BUTTON_CONTENT_BASE}
            strokeWidth='1.9'
            strokeLinecap='round'
        />
    </svg>
);
